export default {
  isPending: false,
};
